<template>
  <div id="app"
       :class="{ 'm-page--boxed': isAuthorized }"
       class="m--full-height m--skin- m-content--skin-light2 m-header--static m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-light m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default">

    <vue-progress-bar></vue-progress-bar>

    <transition name="fade">
      <div v-if="settings.isLoading" class="loader">
        <spinner class="m-auto"/>
      </div>
    </transition>

    <!-- begin:: Page -->
    <div class="m-grid m-grid--hor m-grid--root m-page m--full-height">
      <header-bar v-if="isAuthorized"></header-bar>
      <div class="main-container">
        <div id="app-container"
             class="d-flex m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"
             :class="{ 'no-background': !isAuthorized, 'padding-top-0': !isAuthorized }">

          <button class="m-aside-left-close m-aside-left-close--skin-light " id="m_aside_left_close_btn">
            <i class="la la-close"></i>
          </button>

          <sidebar v-if="isAuthorized"></sidebar>

          <router-view></router-view>

        </div>
      </div>
    </div>

    <div id="m_scroll_top" class="m-scroll-top">
      <i class="la la-arrow-up"></i>
    </div>

    <cookies-modal/>
    <install-pwa-modal v-if="settings.mobileApplication"/>
    <notifications-permission-modal v-if="isAuthorized"/>
  </div>
</template>

<script>
import Sidebar from "@/components/sidebar/Sidebar"
import HeaderBar from "@/components/header/Bar"
import {mapActions, mapState} from 'vuex'
import axios from "@/axios"
import {setViewSettings} from "./store/modules/settings";
import Spinner from "./components/spinner/Spinner";
import InstallPwaModal from "./components/modal/InstallPwaModal";
import NotificationsPermissionModal from "@/components/modal/NotificationsPermissionModal";
import CookiesModal from "@/components/modal/CookiesModal";


export default {
  name: 'app',
  components: {CookiesModal, NotificationsPermissionModal, InstallPwaModal, Spinner, Sidebar, HeaderBar},
  data() {
    return {
      gtmInitialized: false,
    }
  },
  computed: {
    ...mapState({
      isAuthorized: state => state.auth.isAuthorized,
      token: state => state.auth.token,
      entityUuid: state => state.auth.entity.uuid,
      title: state => state.settings.title,
      settings: state => state.settings,
      gtm: state => state.settings.analytics.gtm,
      userVersion: state => state.auth.userVersion,
    })
  },
  created() {
    setViewSettings(this.settings);

    document.querySelector('[name=theme-color]').remove();
    document.querySelector('[name=apple-mobile-web-app-title]').setAttribute('content', this.title);

    //if token exists set Authorization header
    if (this.token.length) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
    }

    if (this.$route.params.hasOwnProperty('uuid')) {
      this.fetchSettings(this.$route.params.uuid);
    } else if (this.entityUuid) {
      this.fetchSettings(this.entityUuid);
    } else {
      this.fetchSettings();
    }

    this.enableGoogleAnalytics();
    if (this.isAuthorized) {
      this.fetchNavigation();
      this.fetchAccountItems();
      this.fetchUser();
      this.fetchAgreements();
      this.fetchRewards();
      this.bumpDateLastLogin();
    }
  },
  methods: {
    ...mapActions([
      'fetchSettings',
      'fetchUser',
      'fetchAgreements',
      'fetchRewards',
      'fetchNavigation',
      'fetchAccountItems',
      'pushToFirstPage'
    ]),
    enableGoogleAnalytics(){
      let googleAnalyticsId = this.settings.analytics.gtm // GTM-XXXXXXX
      if (googleAnalyticsId && !this.gtmInitialized) {
        this.gtmInitialized = googleAnalyticsId;
        this.activateGtm(window,document,'script','dataLayer',googleAnalyticsId);
      }
    },
    activateGtm(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    },
    bumpDateLastLogin() {
      this.$http.post('/user/activity');
    },
  },
  watch: {
    userVersion() {
      this.fetchUser(); //fetch user on version change
      this.fetchAccountItems();
    },
    gtm() {
      this.enableGoogleAnalytics(); //fetch user on version change
    },

  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700");
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700");

:root {
  --bg-image-default: url(./assets/app/media/img/bg/bg-default.jpg) no-repeat fixed;
  --accent-color: '#34bfa3';
  --btn-bg-rgba: '#34bfa3';
  --btn-bg-darker: '#34bfa3';
  --btn-color: '#000000';
  --btn-box-shadow-color: rgba(54, 163, 247, 0.36);
  --checkbox-url:
}

body {
  background: var(--bg-image);
  background-size: cover;
  background-position: center;
  overflow-y: hidden;
}

.form-control:active:not(.m-input), .form-control:focus:not(.m-input), .custom-select:active, .custom-select:focus {
  border: 1px solid var(--accent-color) !important;
}

.custom-select {
  box-shadow: unset !important;
  -webkit-box-shadow: unset !important;
}

.m-input:active::placeholder, .m-input:focus::placeholder {
  color: var(--accent-color) !important;
}

.btn.btn-ls {
  background-color: var(--accent-color) !important;
  border-color: var(--accent-color) !important;
  color: var(--btn-color) !important;
}

.custom-checkbox .custom-control-label::before {
  background-color: #fff !important;
  border-color: var(--accent-color) !important;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23000000' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E") !important;
}

.btn.btn-ls.m-btn--air {
  box-shadow: 0 5px 10px 2px var(--btn-box-shadow-color) !important;
}

.btn.btn-ls:hover {
  background-color: var(--btn-bg-darker) !important;
  border-color: var(--btn-bg-darker) !important;
}

.btn.btn-ls.m-btn--air:hover {
  box-shadow: 0 5px 10px 2px var(--btn-box-shadow-color) !important;
}

.font-ls {
  color: var(--accent-color) !important;
}

.m-badge--ls {
  background: var(--accent-color) !important;
  color: var(--btn-color) !important;
}

.bg-ls {
  background-color: var(--accent-color) !important;
}

.btn-outline-ls {
  color: var(--accent-color) !important;
  border: 1px solid var(--accent-color) !important;
  background: unset;
}

.btn-outline-ls:hover {
  color: var(--btn-color) !important;
  background-color: var(--accent-color) !important;
}

.m-btn--hover-ls:hover {
  background: var(--accent-color) !important;
  color: var(--btn-color);
}

.no-background {
  background: unset !important;
}

#app-container {
  min-height: 100%;
}

#app-container.padding-top-0 {
  padding-top: 0 !important;
}

.main-container {
  height: 100%;
  overflow-y: auto;
}

@media (max-width: 1024px) {
  .main-container {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

.dip img.img {
  -webkit-box-shadow: unset;
  box-shadow: unset;
}

.loader {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
}

.fade-leave-active {
  transition: opacity .5s;
}

.fade-leave-to {
  opacity: 0;
}

.toast-header > .close {
  text-align: right;
}

a.toast-body, a.toast-body:hover {
  color: unset;
}

.notify {
  z-index: 1100 !important;
}
</style>
